import { makeStyles } from '@policygenius/mortar';

export default makeStyles((theme) => ({
  mainCopy: {
    margin: [0, theme.spacing('medium'), theme.spacing('xlarge')],
    [`@media (min-width: ${theme.breakpoints.medium}px)`]: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
}));
